import { Settlements } from "./page/settlement";

const SettlementRoutes = [
  {
    path: "/settlements",
    element: <Settlements />,
  },
];

export default SettlementRoutes;
